import React from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";

const SettingsLinks = () => {
  const route = all_routes;
  const location = useLocation();

  return (
    <>
      <ul className="settings-nav d-flex align-items-center flex-wrap border bg-light-900 rounded">
        <li>
          <Link
            to={route.studentSettings}
            className={`${location.pathname === "/student/student-settings" ? "active" : ""}`}
          >
            Profile
          </Link>
        </li>
        <li>
          <Link
            to={route.studentBillingAddress}
            className={`${location.pathname === "/student/student-billing-address" ? "active" : ""}`}
          >
            Address
          </Link>
        </li>
        <li>
          <Link
            to={route.studentEducationHistory}
            className={`${location.pathname === "/student/student-education-history" ? "active" : ""}`}
          >
            Education History
          </Link>
        </li>
        <li>
          <Link
            to={route.studentWorkExperience}
            className={`${location.pathname === "/student/student-work-experience" ? "active" : ""}`}
          >
            Work Experience
          </Link>
        </li>
        <li>
          <Link
            to={route.studentTestScores}
            className={`${location.pathname === "/student/student-test-scores" ? "active" : ""}`}
          >
            Test Scores
          </Link>
        </li>
        <li>
          <Link
            to={route.studentVisa}
            className={`${location.pathname === "/student/student-visa-study-permit" ? "active" : ""}`}
          >
            Visa & Study Permit
          </Link>
        </li>
        <li>
          <Link
            to={route.studentDocuments}
            className={`${location.pathname === "/student/student-documents" ? "active" : ""}`}
          >
            Documents
          </Link>
        </li>
        <li>
          <Link
            to={route.studentChangePassword}
            className={`${location.pathname === "/student/student-change-password" ? "active" : ""}`}
          >
            Change Password
          </Link>
        </li>
      </ul>
    </>
  );
};

export default SettingsLinks;
